// @ts-nocheck
import cartPromotionIncentiveMessagesReducer, {
    CartPromotionIncentiveMessagesActions,
} from "@store/Framework/Store/Starter/Data/CartPromotionIncentiveMessages/CartPromotionIncentiveMessagesReducer";
import { combineReducers } from "redux";

const dataReducer = combineReducers({
    cartPromotionIncentiveMessages: cartPromotionIncentiveMessagesReducer,
});

export type DataActions = CartPromotionIncentiveMessagesActions;

export default dataReducer;
